function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.846 8.462c0-1.483-.527-2.75-1.58-3.805-1.054-1.053-2.322-1.58-3.804-1.58-1.483 0-2.75.527-3.805 1.58-1.053 1.054-1.58 2.322-1.58 3.805 0 1.482.527 2.75 1.58 3.804 1.054 1.053 2.322 1.58 3.805 1.58 1.482 0 2.75-.527 3.804-1.58 1.053-1.054 1.58-2.322 1.58-3.804zm6.154 10c0 .416-.152.777-.457 1.081a1.479 1.479 0 01-1.081.457c-.433 0-.794-.152-1.082-.457l-4.123-4.11c-1.434.993-3.033 1.49-4.795 1.49a8.315 8.315 0 01-3.288-.667 8.46 8.46 0 01-2.704-1.803A8.46 8.46 0 01.667 11.75 8.315 8.315 0 010 8.462C0 7.316.222 6.22.667 5.174A8.46 8.46 0 012.47 2.47 8.46 8.46 0 015.174.667 8.314 8.314 0 018.462 0c1.145 0 2.241.222 3.287.667a8.46 8.46 0 012.704 1.803 8.46 8.46 0 011.803 2.704 8.315 8.315 0 01.667 3.288c0 1.762-.497 3.36-1.49 4.795l4.122 4.123c.297.296.445.657.445 1.082z",
  fill: "#BCBCBC"
});

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.0f3d1a79.svg";
export { ForwardRef as ReactComponent };